import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'Continue',
    description:
      'Choose your new PIN code. It will be updated right after your first withdrawal.',
    hidePin: 'Hide PIN code',
    showPin: 'Show PIN code',
    title: 'New PIN code',
  },
  fr: {
    cta: 'Continuer',
    description:
      'Choisissez votre nouveau code PIN. Il sera mis à jour juste après votre premier retrait.',
    hidePin: 'Cacher le code PIN',
    showPin: 'Afficher le code PIN',
    title: 'Nouveau code PIN',
  },
} as const);

export default locales;
